import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TechnicalProficiencyPanel from './techproficiencyInformationPanel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import TechnicalProficiencyIcon from '../../../../../assets/images/Ic_Technical Proficiency.png';
import './styles/techproficiency.css';

const TechnicalProficiencies = ({ techproficiencyDocs = [] }) => {
  const [showAll, setShowAll] = useState(false);
  const handleViewAllClick = () => setShowAll((prev) => !prev);

  const visibleSkills = showAll ? techproficiencyDocs : techproficiencyDocs?.slice(0, 6);
  const leftSkills = visibleSkills?.filter((_, index) => index % 2 === 0);
  const rightSkills = visibleSkills?.filter((_, index) => index % 2 !== 0);

  return (
    <Container className="profile-technical-proficiency-container">
      <Row>
        <Col>
          <div className="profile-technical-proficiency-title">
            Technical Proficiency ({techproficiencyDocs?.length ?? 0})
            <img
              src={TechnicalProficiencyIcon}
              alt="Technical Proficiency"
            />
          </div>
        </Col>
      </Row>

      {/* Content for larger screens */}
      <Row className="profile-technical-proficiency-content d-none d-md-flex">
        {/* Left Column */}
        <Col md={6} className="profile-technical-proficiency-left">
          {leftSkills?.map((skill, index) => (
            <TechnicalProficiencyPanel
              key={`left-${index}`}
              colorSeed={Math.random()}
              techproficiency={skill}
            />
          ))}
        </Col>

        <div className="profile-technical-vertical-line"></div>

        {/* Right Column */}
        <Col md={6} className="profile-technical-proficiency-right">
          {rightSkills?.map((skill, index) => (
            <TechnicalProficiencyPanel
              key={`right-${index}`}
              colorSeed={Math.random()}
              techproficiency={skill}
            />
          ))}
        </Col>
      </Row>

      {/* Content for smaller screens */}
      <Row className="d-md-none">
        {visibleSkills?.map((skill, index) => (
          <Col xs={12} key={`small-${index}`} className="profile-technical-proficiency-item-wrapper">
            <TechnicalProficiencyPanel
              colorSeed={Math.random()}
              techproficiency={skill}
            />
          </Col>
        ))}
      </Row>

      {/* View All Button */}
      {techproficiencyDocs?.length > 6 && (
        <Row>
          <Col>
            <a
              className="profile-technical-proficiency-view-all"
              onClick={handleViewAllClick}
            >
              {showAll ? 'View Less' : 'View All'}&nbsp;
              <FontAwesomeIcon icon={showAll ? faChevronUp : faChevronDown} />
            </a>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default TechnicalProficiencies;
